import type { Page } from '@/domain/model/Page';
import type { LgpdSolicitacao, ProcessarLgpdSolicitacaoCommand } from '@/domain/model/Lgpd';
import type { LgpdAdminGateway, ListLgpdSolicitacoesParams } from '@/application/port/out/LgpdAdminGateway';
import type {
  ListLgpdSolicitacoesAdminUseCase, ProcessarLgpdSolicitacaoUseCase,
} from '@/application/port/in/LgpdAdminUseCase';

export class ListLgpdSolicitacoesAdmin implements ListLgpdSolicitacoesAdminUseCase {
  constructor(private readonly g: LgpdAdminGateway) {}
  execute(params: ListLgpdSolicitacoesParams): Promise<Page<LgpdSolicitacao>> {
    return this.g.listSolicitacoes(params);
  }
}

export class ProcessarLgpdSolicitacao implements ProcessarLgpdSolicitacaoUseCase {
  constructor(private readonly g: LgpdAdminGateway) {}
  execute(id: string, cmd: ProcessarLgpdSolicitacaoCommand): Promise<LgpdSolicitacao> {
    return this.g.processar(id, cmd);
  }
}
